import ArrowLeftIconPath from "@ingka/ssr-icon/paths/arrow-left";

export default ArrowLeftIconPath;
